import { useState, useEffect } from "react";
import serverURL from "../../config/serverConfig";
import { useLocation } from "react-router-dom";
import { useClientProjects } from "../../hooks/db";
import ProjectBlobClient from "../projects/ProjectBlobClient";
import { Link } from "react-router-dom";
import ClientIncome from "./ClientIncome";


export default function Client(props) {

    const location = useLocation(); 
    const client_id = location.state?.client_id || props.clientID;
    //const client_ID = Number(props.clientID);
    console.log(typeof(client_id))
    const [clientInfo, setClientInfo] = useState();
    console.log(client_id)
    const clientProjects = useClientProjects(client_id);
    console.log("Client Projects: ", clientProjects);

    useEffect(() => {
        if (!client_id) return;

        fetch(`${serverURL}getClient`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ client_id }),
        })
            .then(response => response.json())
            .then(jsonData => {
                setClientInfo(jsonData[0]);
                console.log("Client info fetched:", jsonData);
            })
            .catch(error => {
                console.error("Error fetching projects:", error);
            });

    }, []);

    return (
        <div id="clientPage" className="max-w-[1500px] flex m-auto px-8">
            {clientInfo ? (

                <div className="p-6 flex flex-col m-aut w-full">
                    <h2 className="text-xl uppercase tracking-wider">{clientInfo.name}</h2>
                    <div className="grid grid-cols-2 gap-2 mt-2 py-5 px-3 rounded-2xl bg-[#181818] text-sm">
                        <p><strong>Email:</strong> {clientInfo.email}</p>
                        <p><strong>Phone:</strong> {clientInfo.phone}</p>
                        <p><strong>Address:</strong> {clientInfo.address}</p>
                        <p><strong>Notes:</strong> {clientInfo.notes}</p>
                    </div>

                    {clientProjects && clientProjects.length > 0 ? (
                        <div className="flex flex-col gap-4 m-auto md:flex-row">
                            <div id="left" className="">
                                <div id="active_projects" className="gradientBG mt-6 p-3 pt-2 max-w-[600px]">
                                    <h4 className="uppercase text-sm">Active Projects</h4>
                                    <div className="hBar mt-[7px] mb-[10px]"></div>
                                    <div>
                                        <div>
                                            {clientProjects.map(project => (
                                                <Link 
                                                    to="/project"
                                                    state={{ project_id: project.project_id }}
                                                    key={project.project_id} 
                                                    className="py-2 border-b border-[#333]"
                                                >
                                                    {/* <strong>{project.title}</strong> - Due: {new Date(project.due_date).toLocaleDateString()} - Status: {project.status} */}
                                                    <ProjectBlobClient project={project} />
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="right">
                                <div id="clientIncomeHistory" className="gradientBG mt-6 p-3 pt-2  min-w-[300px] max-w-[400px]">
                                {/* <div id="clientIncomeHistory" className=""> */}
                                    <ClientIncome clientProjects={clientProjects} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <p>No projects found for this client.</p>
                    )}  

                </div>

            ) : (
                <p>Loading client information...</p>
            )}
        </div>
    )
}